




import { defineComponent } from '@vue/composition-api';

const CommonDivider = defineComponent({
  // setup() {},
});

export default CommonDivider;
